/**
 * Looks up for the implementer user account that have one of
 * the given roles. This became necessary because now an implementer
 * could have many user accounts connected to it.
 * @param {string[]} roles
 * @param {any[]} implementerAccounts
 * @return {{ displayName: string, roles: { role: string }[] } | null}
 */
export const getImplementerAccountByRoles = (
  roles,
  implementerAccounts
) => {
  const matchedAccount = (implementerAccounts || [])
    .find(account =>
      account.roles.some(r => (roles || []).some(roleName => roleName === r.role))
    )

  return matchedAccount || null
}
